// V3 recaptcha
const setRecaptchaToken = (inputEl) => {
  if (window.grecaptcha) {
    window.grecaptcha.ready(function () {
      window.grecaptcha
        .execute("6LeUriooAAAAABgBI359S_WLqi83taQGDDNVoaCM", {
          action: "submit",
        })
        .then(function (token) {
          inputEl.setAttribute("value", token);
        });
    });
  }
};

const RecaptchaCallbacks = [];

const loadRecaptcha = (cb) => {
  const apiScript = document.getElementById("recaptcha-api");
  let hasLoaded = false;

  if (!apiScript) {
    window.onloadCallback = function () {
      hasLoaded = true;

      RecaptchaCallbacks.forEach((cb) => {
        if (typeof cb === "function") {
          cb();
        }
      });
    };

    var script = document.createElement("script");
    script.type = "text/javascript";
    script.id = "recaptcha-api";
    script.async = true;
    script.src =
      "https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit";
    var x = document.getElementsByTagName("script")[0];
    x.parentNode.insertBefore(script, x);
  }

  if (hasLoaded) {
    if (typeof cb === "function") {
      cb();
    }
  } else {
    RecaptchaCallbacks.push(cb);
  }
};

// source: https://developers.google.com/recaptcha/docs/loading
const initV2Invisible = (elForm) => {
  let widgetID = "";
  let formSubmit = false;
  const hiddenInputField = elForm.querySelector(".js-recaptcha-item input");
  const submitButton = elForm.querySelector("button[type=submit]");
  const apiKey = elForm.dataset.sitekey || "";

  const divEl = document.createElement("div");
  divEl.classList.add("sc-form__recaptcha-hidden");
  elForm.append(divEl);

  submitButton.addEventListener("click", (e) => {
    e.preventDefault();
    formSubmit = true;
    window.grecaptcha.execute(widgetID);
    // submitButton.setAttribute("disabled", "true");
    // submitButton.classList.add("is-loading");
  });

  // const enableButton = () => {
  //   submitButton.removeAttribute("disabled");
  //   submitButton.classList.remove("is-loading");
  // };

  const onRecaptchaSuccessV2 = (token) => {
    // enableButton();
    formSubmit = false;
    hiddenInputField.setAttribute("value", token);
    elForm.requestSubmit();
  };

  const onRecaptchaErrorV2 = (err) => {
    console.warn("recaptha error", err);
    // enableButton();
    hiddenInputField.setAttribute("value", "");
    formSubmit && validFields([hiddenInputField.parentElement], elForm);
    formSubmit = false;
  };

  const onRecaptchaExpireV2 = () => {
    hiddenInputField.setAttribute("value", "");
  };

  window.grecaptcha.ready(function () {
    widgetID = window.grecaptcha.render(
      divEl,
      {
        callback: onRecaptchaSuccessV2,
        "expired-callback": onRecaptchaExpireV2,
        "error-callback": onRecaptchaErrorV2,
        size: "invisible",
        sitekey: apiKey,
      },
      true,
    );
  });
};

const initV3recaptcha = (elForm) => {
  const recaptchaInput = elForm.querySelector(".js-recaptcha-input");
  if (typeof window.grecaptcha !== "undefined") {
    setRecaptchaToken(recaptchaInput);

    // fix timeout issue
    setInterval(function () {
      setRecaptchaToken(recaptchaInput);
    }, 110000);
  } else {
    const recaptchaEl = document.querySelector(".js-recaptcha");
    if (recaptchaEl) {
      recaptchaEl.onload = () => setRecaptchaToken(recaptchaInput);

      // fix timeout issue
      setInterval(function () {
        setRecaptchaToken(recaptchaInput);
      }, 110000);
    }
  }
};

export const initRecaptcha = (elForm, handleSuccess, handleError, noJS) => {
  // V2 invisible
  if (elForm.dataset.recaptchaVersion === "v2-invisible") {
    if (typeof window.grecaptcha === "undefined") {
      loadRecaptcha(() => {
        initV2Invisible(elForm);
      });
    } else {
      initV2Invisible(elForm);
    }
    return;
  }

  // V3
  if (elForm.querySelector(".js-recaptcha-input")) {
    initV3recaptcha(elForm);
  }
};

export const resetRecaptcha = (elForm) => {
  // V2 invisible
  if (elForm.dataset.recaptchaVersion === "v2-invisible") {
    return;
  }

  // V3
  const recaptchaInput = elForm.querySelector(".js-recaptcha-input");

  if (recaptchaInput) {
    setRecaptchaToken(recaptchaInput);
  }
};

export const strip = (html) => {
  var doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
};

export const checkIfDirty = (field) => {
  if (field.dataset.isDirty === "true") {
    if (field.value === field.dataset.originalValue) {
      field.parentElement.classList.remove("is-dirty");
      field.dataset.isDirty = "false";
    }
  } else {
    if (field.value !== field.dataset.originalValue) {
      field.parentElement.classList.add("is-dirty");
      field.dataset.isDirty = "true";
    }
  }

  // this flag can be used to position a label over the input
  if (field.value === "") {
    field.parentElement.classList.remove("has-value");
  } else {
    field.parentElement.classList.add("has-value");
  }
  return field.dataset.isDirty;
};

// takes in a field items
// returns true or false
// adds error class to invalid fields
export const validateField = (field, elForm) => {
  let valid = true;
  const re =
    /^.*(?=.{8,})(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W])(?!.*[\s]).*$/;

  switch (field.dataset.type) {
    case "email":
      valid = !!field.value.match(
        /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
      );
      break;
    case "password":
      // more than eight characters
      // contains digits
      // contains lower case alpha
      // contains upper case alpha
      // contains special characters
      // does not contain white space

      valid = re.test(field.value);

      break;
    case "new-password":
      //valid password that doesnt match other password
      const passwordFields = [...elForm.querySelectorAll(".js-new-password")];

      //only return true when there are 2 new password fields
      if (passwordFields.length > 1 && passwordFields.length < 3) {
        const passwordFieldVals = passwordFields.map((field) => field.value);

        /*
                  //if password fields are blank or
                  //bothfields pass regex and are not
                  //equal the new passwords are valid
                  */

        const isBlank = passwordFieldVals.reduce((a, b) => a + b) === "";

        const notEq =
          passwordFieldVals[0] !== passwordFieldVals[1] &&
          re.test(passwordFieldVals[0]) &&
          re.test(passwordFieldVals[1]);

        valid = isBlank ? isBlank : notEq;
      } else {
        valid = false;
      }
      break;
    case "tel":
      valid = !!field.value.match(/^[0-9]*^[()-]*$/) || field.value === "";
      break;

    case "extension":
      valid = !!field.value.match(/^\d{1,4}$/) || field.value === "";
      break;

    case "zip":
      valid = !!field.value.match(
        /^[0-9]{5}$|^[A-Z][0-9][A-Z] ?[0-9][A-Z][0-9]$/,
      );
      break;

    case "website":
      valid =
        !!field.value.match(
          /^(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})$/,
        ) || field.value === "";
      break;

    case "text-length":
      valid =
        strip(unescape(field.value)).length <
          field.getAttribute("data-max-length") || field.value === "";
      break;

    case "checkbox":
      valid = field.checked === true;
      break;

    case "select":
    case "text":
    default:
      if (field.value.trim().length === 0) {
        valid = false;
      }
      if (field.name === "investmentId") {
        valid = !!field.value.match(
          /[iI]{1}[nN]{1}[vV]{1}[\-]{1}[0-9]+$|[oO]{1}[pP]{2}[0-9]+$/,
        );
      }
  }

  return valid;
};

export const handleSubmit = (
  elForm,
  handleSuccess,
  handleError,
  noJs = false,
) => {
  const url = elForm.getAttribute("data-post-url");
  const method = elForm.getAttribute("method").toLowerCase();

  elForm.addEventListener("submit", (e) => {
    const APISubmit = !noJs && method !== "get" && !!url;

    console.log("form submited", { APISubmit });
    if (APISubmit) {
      e.preventDefault();
    }

    [...elForm.querySelectorAll(".has-error")].forEach((el) =>
      el.classList.remove("has-error"),
    );

    if (
      validFields([...elForm.querySelectorAll(".js-form-required")], elForm)
    ) {
      //submit with js only if method != Get, noJS is false, and there is a url.
      if (APISubmit) {
        e.preventDefault();
        [
          ...elForm.querySelectorAll("button[type=submit], input[type=submit]"),
        ].forEach((el) => {
          el.setAttribute("disabled", true);
          el.classList.add("is-loading");
        });

        if (elForm.getAttribute("data-bypass-fetch")) {
          // If a form field name is "submit", form.submit() breaks
          // Calling the prototype method to be sure it'll work
          HTMLFormElement.prototype.submit.call(elForm);
        } else {
          postFormData(elForm, url, handleSuccess, handleError);
        }
      }
    } else {
      e.preventDefault();
      [...elForm.querySelectorAll("button[type=submit]")].forEach((el) => {
        el.removeAttribute("disabled");
        el.classList.remove("is-loading");
      });
      elForm.querySelectorAll(".has-error")[0].focus();
    }
  });
};

export const matchfields = (elForm, items) => {
  let valid = true;

  items.forEach((item) => {
    const field = item.querySelector("[aria-required]");
    const field2Match = elForm.querySelector(`[name=${field.dataset.match}]`);

    if (field === null) {
      return;
    }

    if (field2Match && field2Match.value !== field.value) {
      item.classList.add("has-error");
      valid = false;
    } else {
      item.classList.remove("has-error");
    }
  });

  return valid;
};

// takes in a node array of field items
// returns true or false
export const validFields = (items, elForm) => {
  let valid = true;

  items.forEach((item) => {
    const field = item.querySelector("[aria-required]");

    if (field === null) {
      return;
    }

    if (validateField(field, elForm)) {
      item.classList.remove("has-error");
    } else {
      item.classList.add("has-error");
      valid = false;
    }
  });

  if (elForm.dataset?.recaptchaVersion === "v2-invisible") {
    return valid;
  }

  // Recaptcha V2 checkbox test.
  const recaptchaLabel = document.querySelector(".g-recaptcha-error-label");
  const recaptchaInput = document.querySelector(".g-recaptcha");
  if (window.grecaptcha && window.grecaptcha.getResponse() === "") {
    if (recaptchaInput) {
      recaptchaInput.classList.add("has-error");
    }
    if (recaptchaLabel) {
      recaptchaLabel.classList.add("has-error");
    }
    valid = false;
  } else {
    if (recaptchaInput) {
      recaptchaInput.classList.remove("has-error");
    }
    if (recaptchaLabel) {
      recaptchaLabel.classList.remove("has-error");
    }
  }

  return valid;
};

//stripped down submit handler taken from thread/forms/forms.js
//takes form el, action url, and success and error handler fns
const postFormData = (elForm, url, handleSuccess, handleError) => {
  const params = new FormData(elForm);
  console.log("submitting data", params.entries(), "to", url);

  fetch(url, {
    body: params,
    credentials: "same-origin",
    mode: elForm.dataset.formmode ? elForm.dataset.formmode : "cors",
    method: "post",
  })
    .then((response) => {
      const contentType = response.headers.get("content-type");
      resetRecaptcha(elForm);

      if (contentType && contentType.indexOf("application/json") !== -1) {
        return response.json();
      } else {
        return response.ok;
      }
    })
    .then((data) => {
      if (data.Success) {
        if (data.RedirectUrl) {
          window.location = data.RedirectUrl;
        } else {
          handleSuccess();
        }
      } else {
        handleError(data.Message);
      }
    })
    .catch((err) => {
      handleError();
      resetRecaptcha(elForm);
    });
};

export const setDefaults = (elForm) => {
  // handling the back button with setTimeout
  setTimeout(() => {
    elForm
      .querySelectorAll("input:not([type=submit]), textarea, select")
      //create dataset for form fields
      .forEach((field) => {
        if (field.type === "checkbox" || field.type === "radio") {
          field.dataset.checked = field.checked;
        } else {
          field.dataset.originalValue = field.value;
        }
        checkIfDirty(field);
      });
  }, 100);
};

export const resetDefaults = (elForm) => {
  elForm.reset();

  elForm
    .querySelectorAll("input:not([type=submit]), textarea, select")
    .forEach((field) => {
      if (field.type === "checkbox" || field.type === "radio") {
        if (field.dataset.checked === "true") {
          field.checked = true;
        } else {
          field.checked = false;
        }
      } else {
        field.value = field.dataset.originalValue;
      }
      checkIfDirty(field);
    });

  resetRecaptcha(elForm);
};

export const validationListeners = (item, elForm) => {
  const field = item.querySelector("[aria-required]");

  if (field === null) {
    return;
  }

  if (field.dataset.type !== "select") {
    field.addEventListener("blur", (e) => {
      if (field.getAttribute("data-type") !== "new-password") {
        // ignore blank fields
        if (field.value.trim().length === 0 || validateField(field, elForm)) {
          item.classList.remove("has-error");
        } else {
          item.classList.add("has-error");
        }
      }
      checkIfDirty(field);
    });

    field.addEventListener("focus", (e) => {
      field.parentElement.classList.add("has-value");
    });
  }
};
